import React, { useEffect } from 'react'
import PageWrapper from 'components/PageWrapper'
import { CapacityHeader } from 'components/creditScore'
import { scoreQuestions } from 'constants/creditScore'
import { useCreditScoreStore } from 'store'
import CustomDisclosure from 'components/Disclosure'
import { trackEvent } from 'analytics/trackFunctions'
import { scorePositionMap } from 'utils/moengageEvents'

const Capacity = () => {
  const { creditScore } = useCreditScoreStore()

  useEffect(() => {
    if (creditScore)
      trackEvent({
        eventName: 'bille_sc_pago',
        props: { position: scorePositionMap[creditScore.position] }
      })
  }, [creditScore])

  return (
    <PageWrapper
      className='pb-24 !px-0'
      mobileHeaderColor={creditScore?.position}
      viewSelected='/perfil-crediticio'
      title='Capacidad de pago actual'
    >
      <section className='md:max-w-[60rem] md:mx-auto md:flex-row md:justify-evenly flex  flex-col md:mt-14'>
        {creditScore && <CapacityHeader score={creditScore.position} />}

        <div className='mt-4 px-4 md:px-0 md:mt-0 md:w-1/2 space-y-4'>
          {scoreQuestions.map((value) => {
            const { id, qn, ans } = value
            return <CustomDisclosure key={id} ans={ans} id={id} qn={qn} />
          })}
        </div>
      </section>
    </PageWrapper>
  )
}

export default Capacity
